'use client';

import { useRouter } from 'next/navigation';

interface LockedChapterContentProps {
  price: number;
  onBuyClick: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  isProcessingPayment: boolean;
}

/**
 * Component displayed when user encounters a locked (paid) chapter
 * Shows message about free excerpt and provides options to buy or go back to catalog
 */
export function LockedChapterContent({
  price,
  onBuyClick,
  isProcessingPayment,
}: LockedChapterContentProps) {
  const router = useRouter();

  const handleBackToCatalog = () => {
    router.push('/originals');
  };

  return (
    <div className="max-w-[820px] mx-auto mt-[32px] lg:mt-[46px] flex flex-col items-center justify-center py-16 px-4">
      <div className="text-center mb-6">
        <p className="text-lg font-medium lg:text-xl text-[#1B1D22]">
          Вы прочитали бесплатный отрывок.
          <br />
          Купите полную версию для продолжения чтения
        </p>
      </div>

      <div className="flex flex-wrap gap-5 justify-center">
        <button
          type="button"
          onClick={handleBackToCatalog}
          className="bg-[#BEBEBE] text-white text-[14px] h-10 px-3 rounded-lg hover:bg-[#BEBEBE]/90 transition-colors font-medium"
        >
          Назад в каталог
        </button>

        <button
          type="button"
          onClick={onBuyClick}
          disabled={isProcessingPayment}
          className="bg-[#A84DFF] text-white text-[14px] h-10 px-3 rounded-lg hover:bg-[#A84DFF]/90 disabled:opacity-60 disabled:cursor-not-allowed transition-colors font-medium"
        >
          {isProcessingPayment ? 'Обработка...' : `Купить за ${price} ₽`}
        </button>
      </div>
    </div>
  );
}
